export class UploadDocumentResponse {
    BlocksNumber: number;
    FileSize: number;
    BufferNumber: number;
    SentSize: number;
    Base64String: string;
    BlockIdsList: string[];
}